<template>
  <div>
<div class="dataasset-style" v-if="isMobile">
  <toppage></toppage>
  <div class="dataasset-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>数字资产挽损</h1>
            <img src="@/assets/image/mobile/dataasset/banner1.png" alt="">
            <div class="header-bottom">
              <a
              href="https://graphchain.feishu.cn/share/base/form/shrcnqtRJW0Se37PqJdYeudBuWe" target="_blank">
              
                案件协助</a
              >
            </div>
          </div>
        </div>
    <div class="main-curreny">
      <h1>支持的币种</h1>
      <div class="curreny-content">
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/1.png" alt="">
          <span>BTC</span>
        </span>
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/2.png" alt="">
          <span>ETH </span>
        </span>
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/3.png" alt="">
          <span>USDT </span>
        </span>
      </div>
      <div class="curreny-content">
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/4.png" alt="">
          <span>BNB</span>
        </span>
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/5.png" alt="">
          <span>TRX</span>
        </span>
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/6.png" alt="">
          <span>USDC</span>
        </span>
      </div>
      <div class="curreny-content">
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/7.png" alt="">
          <span>BUSD</span>
        </span>
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/8.png" alt="">
          <span>DAI</span>
        </span>
        <span class="content-info">
          <img src="@/assets/image/mobile/dataasset/9.png" alt="">
          <span>TUSD</span>
        </span>
      </div>
      <div class="main-bottom">
        全面支持所有代币
      </div>
    </div>
        <footerpage></footerpage>
      </div>
      <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="../../assets/image/newhome/huidaodingbu.png" alt="">

</div>
    <div class="dataasset-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section dataasset-top  " >
          <div >

            <div class="dataasset-nav ">
              <navbar classname="businessintroduce" childclassname="dataasset"></navbar>
            </div>
            <div class="section-content ">
              <div class="top-title">
                <div class="header-info">
                 <h1>数字资产挽损</h1>
               <img src="../../assets/image/newhome/dataasset/banner2x.png" alt="">
                 
                </div>
                <div class="title-info">
                    <div class="info-content">

                        <a href="https://graphchain.feishu.cn/share/base/form/shrcnqtRJW0Se37PqJdYeudBuWe" target="_blank">案件协助</a>
                    </div>
           
                 
                </div>
                <!-- <div class="title-content">
             <img src="@/assets/image/newhome/businessintroduce/bannerbeijing.gif" alt="">
            </div> -->
          
              </div>
            </div>
          </div>
        </div>
     
      
       
        <div class="section dataasset-profession">
          <div class="profession-content animated-element1" v-show="isprofession">
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info  ">

                  <h1>支持的币种</h1>
              <div class="dataasset-currency">
            
  <div class="content-main">

      <div class="main-info">
          <div><img src="@/assets/image/currency/BTC.png" alt=""></div>
  <div class="main-right">
      <span>BTC</span>
      <!-- <span>Bitcoin</span> -->
  
  </div>
      </div>
      <div class="main-info">
          <div><img src="@/assets/image/currency/ETH.png" alt=""></div>
  <div class="main-right">
      <span>ETH</span>
      <!-- <span>Etherum</span> -->
  
  </div>
      </div>
      <div class="main-info">
          <div><img src="@/assets/image/currency/usdt.png" alt="">
</div>
  <div class="main-right">
      <span>USDT</span>
      <!-- <span>Tether</span> -->
  
  </div>
      </div>
      <div class="main-info">
          <div><img src="@/assets/image/currency/bnb.png" alt=""></div>
  <div class="main-right">
      <span>BNB</span>
      <!-- <span>BNB</span> -->
  
  </div>
      </div>
      <div class="main-info">
          <div><img src="@/assets/image/currency/TRX.png" alt=""></div>
  <div class="main-right">
      <span>TRX</span>
      <!-- <span>TRON</span> -->
  
  </div>
      </div>
  </div>
  
    <div class="content-main">
        <div class="main-info">
            <div><img src="@/assets/image/currency/USDC.png" alt=""></div>
    <div class="main-right">
        <span>USDC</span>
        <!-- <span>USDC</span> -->
    
    </div>
        </div>
        <div class="main-info">
            <div><img src="@/assets/image/currency/BUSD.png" alt=""></div>
    <div class="main-right">
        <span>BUSD</span>
        <!-- <span>BUSD</span> -->
    
    </div>
        </div>
        <div class="main-info">
            <div><img src="@/assets/image/currency/Dai.png" alt=""></div>
    <div class="main-right">
        <span>DAI</span>
        <!-- <span>DAI</span> -->
    
    </div>
        </div>
      
        <div class="main-info">
            <div><img src="@/assets/image/currency/tusd.png" alt=""></div>
    <div class="main-right">
        <span>TUSD</span>
        <!-- <span>TrueUSD</span> -->
    
    </div>
        </div>
         
    </div>
  
   
              </div>
              <div class="currency-bottom">
                <span>全面支持所有代币</span>
              </div>
                </div>
       
            <!-- <div class="liucheng-button">
              <span>联系我们</span>
            </div> -->
              </div>
           
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </div>
  </template>
  <script>
  import navbar from "@/components/navbar.vue";
  import newfooter from "@/components/newfooter.vue";
  // import countTo  from 'vue-count-to';
  // import CountUp from "countup"
  import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";
  export default {
    components: {
      navbar,
      newfooter,
      toppage,
    footerpage,
      // countTo 
    },
    data() {
      return {
        deviceType: this.getDeviceType(),
        showButton: false,
      scrollThreshold: 400,
   isMobile: false,
        // isshebi:false,
        iscorebusiness1:false,
        iscorebusiness2:false,
        isprofession:false,
        screenWidth: 0,
        bannerHeight: 0,
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          //是否显示导航，默认为false
          navigation: true,
   afterLoad: this.afterLoad,
   onLeave:this.onLeave,

          //为每个section设置背景色
          // sectionsColor: [
          //     "#41b883",
          //     "#ff5f45",
          //     "#0798ec",
          //     "#fec401",
          //     "#1bcee6",
          //     "#ee1a59",
          //     "#2c3e4f",
          //     "#ba5be9",
          //     "#b4b8ab"
          // ],
        },
      };
    },
    methods: {
      scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
      getDeviceType() {
      return window.innerWidth < 768 ? "手机" : "电脑";
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
      afterLoad(anchorLink,index) {
        console.log(anchorLink,index);
          console.log("Emitted 'after load' event.")
          //获取body的classname，跟随section滑动刷新
          let a = document.body.className
          console.log(a);
          //在第几页控制相关逻辑
        //   if(a !== 'fp-scroll-mac fp-viewing-0' || a !== 'fp-viewing-0'){
        //     this.isshebi=false
        //   }
  
          if(a !== 'fp-scroll-mac fp-viewing-1' || a !== 'fp-viewing-1'){
            this.isprofession=false
          }
          if (a === 'fp-scroll-mac fp-viewing-1' || a === 'fp-viewing-1') {
            // console.log(eee);
            this.isprofession=true
     
        }
        // else if(a === 'fp-scroll-mac fp-viewing-0' || a === 'fp-viewing-0'){
        //   this.isshebi=true
        // }
        },
  
   
      next() {
        // 向下滚动一页
        this.$refs.fullpage.api.moveSectionUp();
// this.$refs.fullpage.goTo(0);
      },
    },
    // created(){     location.reload()},
    mounted() {
      if (this.deviceType != "手机" && !this.isMobile) {
      this.next();
    }
    if(this.isMobile){

window.addEventListener('scroll', () => {
  this.showButton = window.scrollY > this.scrollThreshold;
});
}
      // 首次加载时,初始化高度
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (450 / 1450) * this.screenWidth;
      // 窗口大小发生改变
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
        this.bannerHeight = (450 / 1450) * this.screenWidth;
      };
      
    },
    created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', () => {});

  },
  };
  </script>
  <style>
  .fp-warning,
  .fp-watermark {
    display: none !important;
  }
  </style>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/dataasset.scss";
  </style>
  